import { BitfStrapiModel } from '@common/libs/bitforce/core/models/strapi/bitf-strapi.model';
export class User extends BitfStrapiModel {
  username: string;
  email: string;
  full_name: string;

  constructor(data?: any) {
    super({
      data,
      serializeProperties: ['id', 'username', 'email', 'full_name'],
    });
  }

  get fullName() {
    return this.full_name || this.username || this.email;
  }

  get canViewLogs() {
    return true;
  }
}
